import { Fragment } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../main/Header";
import Footer from "../main/Footer";
import layoutClasses from "./Layout.module.css";

function isAuthShellRoute(pathname) {
  return (
    pathname === "/login" ||
    pathname === "/forgotPassword" ||
    pathname.startsWith("/resetPassword/")
  );
}

const Layout = () => {
  const { pathname } = useLocation();
  const mainClassName = isAuthShellRoute(pathname)
    ? `${layoutClasses.main} ${layoutClasses.mainAuth}`
    : layoutClasses.main;

  return (
    <Fragment>
      <Header />
      <main className={mainClassName}>
        <Outlet />
      </main>
      <Footer />
    </Fragment>
  );
};

export default Layout;
